import e, { Children as E, useRef as b, useState as i } from "react";
import p from "classnames";
import { Slider as S } from "../Slider/Slider.js";
import s from "./smallSlider.module.scss.js";
const g = e.forwardRef((r, m) => {
  const {
    children: a,
    beforeChange: c
  } = r, o = E.count(a), t = m ?? b(null), [d, _] = i(!1), [u, v] = i(!0), f = {
    speed: 500,
    ...r,
    className: p(r.className, s.slick),
    dots: !1,
    infinite: !1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !1,
    beforeChange: (l, n) => {
      v(n !== o - 1), _(n !== 0), c == null || c(l, n);
    }
  }, N = () => {
    var l;
    (l = t == null ? void 0 : t.current) == null || l.slickNext();
  }, h = () => {
    var l;
    (l = t == null ? void 0 : t.current) == null || l.slickPrev();
  };
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "small-slider", className: s.slider }, /* @__PURE__ */ e.createElement(S, { ref: t, settings: f }, a), /* @__PURE__ */ e.createElement("div", { className: s.slider__controls }, /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${s.slider__control} ${s.slider__control__prev}`,
      disabled: !d,
      type: "button",
      onClick: () => h()
    },
    /* @__PURE__ */ e.createElement("i", { className: "lni lni-chevron-left" })
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      className: `${s.slider__control} ${s.slider__control__next}`,
      disabled: !u || o === 1,
      type: "button",
      onClick: () => N()
    },
    /* @__PURE__ */ e.createElement("i", { className: "lni lni-chevron-right" })
  )));
});
export {
  g as SmallSlider
};
//# sourceMappingURL=SmallSlider.js.map
